module.exports = __webpack_public_path__ + "static/media/tick-success.c654bd59.svg";